<script >
import "@futuweb/task-component-client/lib/index.css";
import Container from '../components/Container/index.vue';
import Main from '../components/Main/index.vue';
const __sfc_main = {};
__sfc_main.props = {
  encryptConfig: {
    type: String,
    required: true
  },
  isDark: {
    type: Boolean,
    default: false
  },
  isHide: {
    type: Boolean,
    default: false
  },
  market: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  return {};
};
__sfc_main.components = Object.assign({
  Container,
  Main
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <Container id="common-task-list">
        <Main :encrypt-config="encryptConfig" :is-dark="isDark" :is-hide="isHide" :market="market"/>
    </Container>
</template>
<style lang="less" scoped>
@import '../assets/less/index.less';
</style>
